import React from 'react';
import imgStars from '../../assets/stars.webp';  // Assuming you have a stars image
import imgUser from '../../assets/user.webp';   // Assuming you have a user image

const Review = () => {
    return (
        <>
            <div className="testimonial-section">
                <div className="container">
                    <h5 className="section-head head-review-copy">Aussie Pools Love It</h5>
                    <div className="row py10 pad-web">
                        <div className="col-md-6 col-lg-4 ">
                            <div className="card-testimonial">
                                <img src={imgStars} alt="Stars" className="star-img" />
                                <h4 className="testimonial-head pe-2">Saved $200 - Pool’s perfect!</h4>
                                <div className="align-items-center d-flex gap10">
                                    <img src={imgUser} alt="User" className="user-img" />
                                    <span className="user-name">– @JohnGC76</span>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-4">
                            <div className="card-testimonial">
                                <img src={imgStars} alt="Stars" className="star-img" />
                                <h4 className="testimonial-head pe-2">Green to clean in a day!</h4>
                                <div className="align-items-center d-flex gap10">
                                    <img src={imgUser} alt="User" className="user-img" />
                                    <span className="user-name">– @ShazPerth</span>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-4 ">
                            <div className="card-testimonial">
                                <img src={imgStars} alt="Stars" className="star-img" />
                                <h4 className="testimonial-head pe-2">HelpBot fixed my pH at 2am.</h4>
                                <div className="align-items-center d-flex gap10">
                                    <img src={imgUser} alt="User" className="user-img" />
                                    <span className="user-name">– @DaveSyd73</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <h6 className="trusted-pool">Trusted by 800+ Pool Owners</h6>
                        <div className="text-center">
                            <button className="btn trusted-btn landing-slider-button">See Why — Start Your Free Trial</button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Review;
